export default {
  "profile": {
    "personalDetailsSections": "Personal details sections",
    "middleNameS": "Middle name(s)",
    "preferredDisplayName": "Preferred/display name",
    "leaveBlankIfNotApplicable": "Leave blank if not applicable.",
    "mobileNumber": "Mobile number",
    "allergyDetails": "Allergy details",
    "dietaryLifestyleNotes": "Dietary/lifestyle notes",
    "searchActiveClubMembers": "Search active club members",
    "nameOrMembershipNumber": "Name or membership number",
    "selectedMemberIsMy": "Selected member is my",
    "membershipStatus": "Membership status",
    "currentAvatar": "Current avatar",
    "mr": "Mr",
    "mrs": "Mrs",
    "miss": "Miss",
    "ms": "Ms",
    "dr": "Dr",
    "prof": "Prof",
    "sir": "Sir",
    "dame": "Dame",
    "lord": "Lord",
    "lady": "Lady",
    "rev": "Rev",
    "work": "Work",
    "holidayHome": "Holiday Home",
    "postal": "Postal",
    "car": "Car",
    "motorcycle": "Motorcycle",
    "van": "Van",
    "golfBuggy": "Golf buggy",
    "grandparent": "Grandparent",
    "grandchild": "Grandchild",
    "dependant": "Dependant",
    "label": "Label",
    "addressType": "Address type",
    "addressLine1": "Address line 1",
    "addressLine2": "Address line 2",
    "townOrCity": "Town or city",
    "countyStateOrRegion": "County, state or region",
    "postcodeOrZIPCode": "Postcode or ZIP code",
    "country": "Country",
    "registrationLicencePlate": "Registration / licence plate",
    "make": "Make",
    "model": "Model",
    "colour": "Colour",
    "vehicleType": "Vehicle type",
    "fullName": "Full name",
    "relationship": "Relationship",
    "alternativeTelephone": "Alternative telephone",
    "emailAddress": "Email address",
    "otherDietaryRequirement": "Other dietary requirement",
    "recreational": "Recreational",
    "social": "Social",
    "club": "Club",
    "competitive": "Competitive",
    "elite": "Elite",
    "discardChanges": "Discard changes?",
    "youHaveUnsavedChanges": "You have unsaved changes.",
    "ifYouContinueYourChangesWillBeLost": "If you continue, your changes will be lost.",
    "discard": "Discard",
    "removeFamilyRelationship": "Remove family relationship?",
    "thisWillRemoveTheFamilyRelationshipForBothMembers": "This will remove the family relationship for both members.",
    "thisActionCannotBeUndoneAutomatically": "This action cannot be undone automatically.",
    "keepRelationship": "Keep relationship",
    "removeVehicle": "Remove vehicle?",
    "removeAddress": "Remove address?",
    "thisVehicleWillBeRemovedFromYourProfile": "This vehicle will be removed from your profile.",
    "thisAddressWillBeRemovedFromYourProfile": "This address will be removed from your profile.",
    "saveChanges": "Save changes",
    "sending": "Sending…",
    "sendRequest": "Send request",
    "removing": "Removing…",
    "confirming": "Confirming…",
    "accepting": "Accepting…",
    "confirmRemoval": "Confirm removal",
    "acceptRelationship": "Accept relationship",
    "keeping": "Keeping…",
    "rejecting": "Rejecting…",
    "reject": "Reject",
    "removalRequest": "Removal request",
    "cancelling": "Cancelling…",
    "cancelRequest": "Cancel request",
    "addVehicle": "Add Vehicle",
    "addAddress": "Add Address",
    "mainPostalAddress": "Main postal address",
    "saveVehicle": "Save Vehicle",
    "saveAddress": "Save Address",
    "primary": "Primary",
    "uploading": "Uploading…",
    "uploadNewPhoto": "Upload new photo",
    "updated": "Updated.",
    "memberNumberUnavailable": "Member number unavailable",
    "enterAtLeastTwoCharactersToFindAnActive": "Enter at least two characters to find an active club member.",
    "keepTypingToSearchActiveClubMembers": "Keep typing to search active club members.",
    "noMatchingMembersFound": "No matching members found.",
    "hasRequestedToRemoveYourFamilyRelationship": "Has requested to remove your family relationship.",
    "hasRequestedToAddYouAsTheirRelation": "Has requested to add you as their {relation}.",
    "relationRelationshipRequest": "{relation} relationship request",
    "unableToRemoveVehicle": "Unable to remove vehicle.",
    "unableToRemoveAddress": "Unable to remove address.",
    "weCouldNotSaveYourChangesYourEditsAre": "We could not save your changes. Your edits are still here. Please try again.",
    "weCouldNotLoadYourDetailsPleaseTryAgain": "We could not load your details. Please try again.",
    "yourSessionOrAccessCouldNotBeVerifiedPlease": "Your session or access could not be verified. Please sign in again or contact the club.",
    "thisServiceIsUnavailablePleaseReopenTheAppOr": "This service is unavailable. Please reopen the app or contact the club.",
    "pleaseCheckTheHighlightedFieldsAndTryAgain": "Please check the highlighted fields and try again.",
    "saved": "Saved.",
    "yourChangesWereSavedButTheProfileSummaryCould": "Your changes were saved, but the profile summary could not refresh.",
    "refreshSummary": "Refresh summary",
    "enterAValidEmailAddress": "Enter a valid email address",
    "enterAValidTelephoneNumber": "Enter a valid telephone number",
    "invalidDate": "Invalid date",
    "dateCannotBeInTheFuture": "Date cannot be in the future",
    "enterAMoreRecentDate": "Enter a more recent date",
    "addressLine1TownCityAndCountryAreRequired": "Address line 1, town/city and country are required",
    "registrationIsRequired": "Registration is required",
    "htmlIsNotAllowed": "HTML is not allowed",
    "maximumCountCharacters": "Maximum {count} characters",
    "pleaseSelectAnImageFile": "Please select an image file",
    "pleaseChooseAnImageUnder8MB": "Please choose an image under 8MB",
    "unableToRemovePhoto": "Unable to remove photo",
    "unableToSavePortraitPreferenceRightNow": "Unable to save portrait preference right now.",
    "enter00360OrUseForA": "Enter 0.0–36.0, or use + for a plus handicap up to +5.0.",
    "profilePhotoUpdated": "Profile photo updated.",
    "ready": "Ready",
    "yourPortraitIsNowLive": "Your portrait is now live.",
    "weArePreparingYourPortrait": "We are preparing your portrait.",
    "profilePhotoRemoved": "Profile photo removed.",
    "notSet": "Not set",
    "addYourLevelForBetterMatchesAndRecommendations": "Add your level for better matches and recommendations.",
    "handicap": "Handicap",
    "levelNumber": "Level {number}",
    "notSaved": "Not saved",
    "setLevel": "Set level",
    "currentHandicap": "Current handicap",
    "currentTier": "Current tier",
    "golfHandicap": "Golf handicap",
    "preparing": "Preparing…",
    "bringProfileToLife": "Bring profile to life",
    "switchToPhoto": "Switch to photo",
    "switchToLivePortrait": "Switch to live portrait",
    "livePortrait": "Live portrait",
    "sportPlayingLevel": "{sport} playing level",
    "golfHandicapNumber": "Golf handicap {number}",
    "sportTierLevelNumber": "{sport}, {tier} level, level {number}",
    "handicapNumber": "Handicap {number}",
    "nameLivePortrait": "{name} live portrait",
    "viewPhoto": "View photo",
    "viewLivePortrait": "View live portrait",
    "tierLevel": "{tier} level"
  },
  "dining": {
    "somethingWentWrongPleaseTryAgain": "Something went wrong. Please try again.",
    "thatTableTimeWasJustBookedPleaseChooseAnother": "That table time was just booked. Please choose another available time.",
    "chooseAValidDateAndTimeInYourClub": "Choose a valid date and time in your club’s timezone.",
    "thisReservationIsNowInsideTheClubSCancellation": "This reservation is now inside the club’s cancellation window. Please contact the club.",
    "yourMemberSessionHasExpiredPleaseSignInAgain": "Your member session has expired. Please sign in again.",
    "youAppearToBeOfflineCheckYourConnectionAnd": "You appear to be offline. Check your connection and try again.",
    "thisPartySizeIsNotSupportedForOnlineReservations": "This party size is not supported for online reservations.",
    "thisDiningAreaIsNotTakingReservationsOnThe": "This dining area is not taking reservations on the selected date.",
    "theSelectedDateOrTimeIsInsideTheMinimum": "The selected date or time is inside the minimum-notice period.",
    "onlineReservationsAreNotCurrentlyAvailableForThisDining": "Online reservations are not currently available for this dining area.",
    "weCouldnTCheckTableAvailabilityPleaseTryAgain": "We couldn’t check table availability. Please try again.",
    "noTablesAreAvailableForThatDateTryAnother": "No tables are available for that date. Try another time or date.",
    "diningReservationsAreNotCurrentlyAvailable": "Dining reservations are not currently available.",
    "someDiningInformationCouldNotBeRefreshed": "Some dining information could not be refreshed.",
    "weCouldnTReadTheAvailableTimesPleaseTry": "We couldn’t read the available times. Please try again.",
    "yourReservationCouldNotBeCompleted": "Your reservation could not be completed.",
    "theReservationCouldNotBeCancelled": "The reservation could not be cancelled.",
    "confirmed": "Confirmed",
    "seated": "Seated",
    "noShow": "No show",
    "diningArea": "Dining area",
    "dismissError": "Dismiss error",
    "loadingDiningAreas": "Loading dining areas",
    "removeOneGuest": "Remove one guest",
    "addOneGuest": "Add one guest",
    "loadingAvailableTimes": "Loading available times",
    "findAvailableTables": "Find Available Tables",
    "yourSearchWasNotTreatedAsAnEmptyResult": "Your search was not treated as an empty result.",
    "tryNearbyTimesAnotherDateOrAdjustYourParty": "Try nearby times, another date, or adjust your party size.",
    "changeDate": "Change date",
    "allergiesAccessibilityRequirementsBirthdaysOrAnniversaries": "Allergies, accessibility requirements, birthdays or anniversaries…",
    "reservingYourTable": "Reserving your table…",
    "updateReservation": "Update Reservation",
    "reserveTable": "Reserve Table",
    "loadingReservations": "Loading reservations",
    "noPreviousReservations": "No previous reservations",
    "closeReservationDetails": "Close reservation details",
    "diningAreaUnavailable": "Dining area unavailable",
    "unavailable": "Unavailable",
    "onlineCancellationIsAvailable": "Online cancellation is available.",
    "submitted": "submitted",
    "nameDiningArea": "{name} dining area",
    "countGuest": "{count} guest",
    "countGuests": "{count} guests",
    "countRecent": "{count} recent",
    "timeUnavailable": "Time unavailable",
    "dateUnavailable": "Date unavailable",
    "chooseADiningAreaDateAndValidPartySize": "Choose a dining area, date, and valid party size.",
    "countRecentOne": "{count} recent"
  },
  "golf": {
    "preparingYourRound": "Preparing your round",
    "gettingCoursesAndPlayersReady": "Getting courses and players ready",
    "loadingScoringTees": "Loading scoring tees",
    "loadingActiveRounds": "Loading active rounds",
    "golfCourse": "Golf course",
    "startingRound": "Starting round…",
    "startRound": "Start round",
    "deleteRound": "Delete round",
    "course": "Course",
    "golfSetupStep": "Golf setup: {step}",
    "strokePlay": "Stroke Play",
    "countEveryStrokeAcrossTheRound": "Count every stroke across the round.",
    "stableford": "Stableford",
    "playForPointsOnEveryHole": "Play for points on every hole.",
    "nameTees": " · {name} tees",
    "weCouldnTStartTheRoundNothingHasBeen": "We couldn’t start the round. Nothing has been recorded — please try again.",
    "deleteCourseRound": "Delete {course} round",
    "guestName": "Guest — {name}",
    "removeName": "Remove {name}",
    "today": "Today",
    "yesterday": "Yesterday",
    "checkingSportAvailability": "Checking sport availability",
    "loadingClubSports": "Loading club sports",
    "findingWhatSAvailableToday": "Finding what’s available today",
    "playARound": "Play a round",
    "takeToTheCourt": "Take to the court",
    "loadingLetSPlay": "Loading Let’s Play",
    "weCouldnTLoadThisCompletedActivity": "We couldn’t load this completed activity.",
    "momentFromName": "Moment from {name}",
    "round": "round",
    "activity": "activity",
    "countHoles": "{count} holes · ",
    "countHoles225": " · {count} holes",
    "round226": "Round",
    "round227": "Round",
    "preparingYourActivitySummary": "Preparing your activity summary",
    "loadingActivity": "Loading activity",
    "roundCOMPLETE": "ROUND COMPLETE",
    "countBirdie": "{count} Birdie",
    "countBirdies": "{count} Birdies",
    "countEagle": "{count} Eagle",
    "countEagles": "{count} Eagles",
    "countAlbatross": "{count} Albatross",
    "countAlbatrosses": "{count} Albatrosses",
    "countHoleInOne": "{count} Hole in One",
    "countHolesInOne": "{count} Holes in One",
    "weCouldnTLoadYourHistory": "We couldn’t load your history.",
    "countHoles240": " · {count} holes",
    "round241": "Round",
    "round242": "Round",
    "birdie": "BIRDIE",
    "nicelyJudged": "Nicely judged.",
    "cleanWork": "Clean work.",
    "oneBetter": "One better.",
    "thatLlPlay": "That’ll play.",
    "eagle": "EAGLE",
    "thatLlDo": "That’ll do.",
    "twoBetterVeryTidy": "Two better. Very tidy.",
    "nowWeReTalking": "Now we’re talking.",
    "exceptional": "Exceptional.",
    "albatross": "ALBATROSS",
    "wellThatEscalated": "Well, that escalated.",
    "threeUnderAbsurd": "Three under. Absurd.",
    "youDonTSeeThatEveryDay": "You don’t see that every day.",
    "ridiculousInTheBestWay": "Ridiculous. In the best way.",
    "holeINONE": "HOLE IN ONE",
    "oneSwingThatSAllItTook": "One swing. That’s all it took.",
    "someoneSBuyingTheDrinks": "Someone’s buying the drinks.",
    "straightInTheHistoryBook": "Straight in the history book.",
    "perfectlyUnnecessarySecondShot": "Perfectly unnecessary second shot.",
    "titleForName": "{title} for {name}.",
    "preparingYourMoment": "Preparing your moment…",
    "continueAfterTitleForName": "Continue after {title} for {name}",
    "thisRoundWillBeRemovedFromLetSPlay": "This round will be removed from Let’s Play and you won't be able to continue scoring it."
  }
}
